// About Information
export const about = {
    info: `Software Engineer @Charles Schwab | Ex-Software Developer @Paycom | Ex-SDE @GMFinancial | MS in Computer Science | University of Texas at Arlington`,
    imageSrc: "/images/profile.jpeg"
};

// Interest Information
export const interest = {
    interest: `Software engineering | Full-Stack Software development | Backend Software development | Enterprise business applications | Artificial Intelligence | Machine Learning`
};

// Education Information
export const education = [
    {
        school: "The University of Texas at Arlington",
        degree: "Master of Science in Computer Science | Specializations: Software Engineering and Artificial Intelligence",
        duration: "Jan 2024 - August 2025"
    },
    {
        school: "The University of Texas at Arlington",
        degree: "Honors Bachelor of Science, Accounting and Computer Science",
        duration: "August 2019 - December 2023"
    }
];

// Experience Information
export const experience = [
    {
        company: "Charles Schwab",
        role: "Software Engineer",
        duration: "June 2026 - Present"
    },
    {
        company: "Paycom",
        role: "Software Developer",
        duration: "August 2025 - February 2026"
    },
    {
        company: "GM Financial",
        role: "Software Development Engineer Intern",
        duration: "May 2025 - August 2025"
    },
    {
        company: "UT Arlington Libraries",
        role: "Graduate Research Assistant",
        duration: "June 2024 - May 2025"
    },
    {
        company: "Howard, LLP (Merged to Bonadio Group)",
        role: "Audit Associate",
        duration: "Jan 2023 - Aug 2023"
    },
    {
        company: "CLA (Clifton Larson Allen)",
        role: "Tax Accountant",
        duration: "Jan 2022 - Apr 2022"
    },
    {
        company: "May Mobility",
        role: "Accountant",
        duration: "May 2021 - Dec 2021"
    },
];

// Leadership and College Organizations
export const leadership = [
    {
        organization: "Open Education Student Advocacy Group (OESAG)",
        role: "Founder and President",
        duration: "June 2024 - May 2025"
    },
    {
        organization: "Beta Gamma Sigma",
        role: "Member",
        duration: "Feb 2022 - Dec 2023"
    },
    {
        organization: "Honors College",
        role: "Member",
        duration: "August 2019 - Dec 2023"
    },
    {
        organization: "Accounting Society",
        role: "Vice President | Member",
        duration: "Jan 2020 - Dec 2021"
    },
]

export const technicalSkills = [
    {
        title: "Programming Languages",
        description: "JavaScript, Java, C, Python, Kotlin, SQL, TypeScript."
    },
    {
        title: "Frameworks and Libraries",
        description: "React JS, Bootstrap, jQuery, Node.js, Express.js, Axios, Spring Boot, Spring MVC, JUnit, tkinter, numpy, scipy."
    },
    {
        title: "Database",
        description: "PostgreSQL, SQLite, MySQL, NoSQL, Firebase."
    },
    {
        title: "Methodologies",
        description: "Agile, Waterfall, Spiral Process, Unified Process."
    },
    {
        title: "Software Design Patterns",
        description: "Visitor, Creator, Singleton, State, Expert, Composite, GRASP, Other GoF patterns."
    },
    {
        title: "Web Technologies",
        description: "HTML 5, EJS, CSS, XML, JSON, REST, Github Pages, WordPress, Wix, Canva."
    },
    {
        title: "Tools",
        description: "Git, GitHub, npm, Postman, VS Code, Wireshark, Anaconda."
    },

]

export const projects = [
    {
        title: "StockSync: Real-Time Inventory Management System",
        techStack: "React, Node.js, PostgreSQL, Express.js, JavaScript",
        imageSrc: "/images/inventory.png",
        category:"Full-stack application",
        description: `StockSync is a comprehensive full-stack project designed to manage perpetual inventory systems in accounting. 
        The application provides real-time inventory valuation using the average inventory pricing method, crucial for calculating the cost of sales 
        for financial reporting. Users can manage their profiles, customer and supplier information, inventory items, transactions, and more.`,
        link: "https://github.com/anamolkhadka/StockSync_Public"
    },
    {
        title: "Travella – Your AI-Powered Travel Assistant",
        imageSrc: "/images/travella.png",
        techStack: "Node.js, Express.js, Firebase, Amadeus API, TripAdvisor API, OpenAI API, Google Places API, FlightAware, OpenWeather, React.js, React Bootstrap, Axios, jsPDF, Mocha, Supertest, Chai.",
        category: "Full-stack application",
        description: "Travella is an all-in-one AI-powered travel companion that simplifies trip planning with intelligent itinerary generation, real-time flight and weather updates, hotel and flight bookings, expense tracking, and live flight alerts, supported by robust backend and frontend integrations.",
        link: "https://github.com/anamolkhadka/travella"

    },
    {
        title: "Student Information Exchange (Android application)",
        imageSrc: "/images/SIE.png",
        techStack: "Kotlin, XML, Firebase, NoSQL, Android Studio",
        category:"Mobile application",
        description: `Student Information Exchange is an Android application that helps the university students to exchange information. 
        Students can use this app to form an organization/clubs , buy/sell/trade second hand items , request for tutoring services , 
        direct message to the individuals or in the Group , search for any Upcoming events , and much more.`,
        link: "https://github.com/anamolkhadka/Student_Information_Exchange_project"
    },
    {
        title: "Car Rental Service",
        imageSrc: "/images/carRental.png",
        techStack: "Python, tkinter, SQL, SQLite",
        category:"Full-stack application",
        description: `This is a car rental database management application created for businesses providing car rental services. 
        This application is created using Python for front-end/back-end and SQLite for database management.`,
        link: "https://github.com/anamolkhadka/carRental"
    },
    {
        title: "QuickDoc - AI Doctor Chatbot",
        imageSrc: "/images/quickDoc.png",
        techStack: "React.js, Vite, OpenAI GPT-4o Mini, Bootstrap, Axios, Session Storage, React Bootstrap, Bootstrap Icons.",
        category: "Aritificial Intelligence / Machine Learning",
        description: "QuickDoc is an AI-powered virtual doctor chatbot that provides general medical advice using OpenAI GPT models. Built with React.js and Bootstrap, it offers real-time chat interactions, session-based chat history, and polished UI for a friendly health assistant experience.",
        link: "https://github.com/anamolkhadka/quickdoc-ai"
    },    
    {
        title: "Stock Analyzer",
        imageSrc: "/images/stockAnalyzer.png",
        techStack: "React.js, Axios, React-Bootstrap, Chart.js, Firebase, Vercel, Polygon.io Stock API",
        category:"Full-stack application",
        description: `The Stock Analyzer Web App is a simple, intuitive tool designed to help users track and analyze stocks using data from the Polygon.io API. 
        Users can search for stocks, add them to a personalized list, and view detailed stock information, including charts, financial analysis and technical analysis indicators.`,
        link: "https://hack-uta-6.vercel.app/"
    },
    {
        title: "My Journal",
        imageSrc: "/images/myjournal.png",
        techStack: "React, JavaScript, Firebase, NodeJS, HTML, CSS, Boostrap 5",
        category:"Full-stack application",
        description: `My Journal is a react based web application that is integrated with the real time database management system with firestone. 
        This web app provides a platform to any users to create an online Journal for record keeping and expressing their daily activities, events and emotions they want to convey.`,
        link: "https://github.com/anamolkhadka/myjournal"
    },
    {
        title: "Red-Blue Nim Game (Min-Max Problem)",
        imageSrc: "/images/minmax.png",
        techStack: "Python, Min-Max Algorithm, Alpha-beta pruning, Depth-Limited Search",
        category:"Aritificial Intelligence / Machine Learning",
        description: `This project is an implementation of the Red-Blue Nim game using the Min-Max algorithm with Alpha-Beta Pruning, designed as part of an AI coursework assignment. 
        The game features two versions: standard and misère, with the goal of optimizing the computer's strategy to either win or minimize losses based on the rules of the version being played.`,
        link: "https://github.com/anamolkhadka/CSE5360_red_blue_nim"
    },
    {
        title: "Bayesian Network Classifier",
        imageSrc: "/images/bayesianNetwork.png",
        techStack: "Python, Bayesian Network, Bayes Classifier, Conditional Probabilities, Joint Probability Distribution, Inference by Enumeration.",
        category:"Aritificial Intelligence / Machine Learning",
        description: `This project implements a Bayesian Network Classifier that learns conditional probability tables (CPTs) from training data and performs inference using enumeration.`,
        link: "https://github.com/anamolkhadka/CSE5360_bayesian_classifier"
    },
    {
        title: "Linear & Logistic Regression Models on Iris Dataset",
        imageSrc: "/images/iris.jpg",
        techStack: "Python, NumPy, Scikit-learn, Linear Regression, Logistic Regression, Iris Dataset, Model Evaluation, Gradient Descent, Regularization",
        category:"Aritificial Intelligence / Machine Learning",
        description: `This project implements linear and logistic regression from scratch, applied to the Iris dataset, with training, evaluation, and loss curve visualizations.`,
        link: "https://github.com/anamolkhadka/linear-logistic-regression-iris"
    },
    {
        title: "Neural Network Library & NYC Taxi Predictions",
        imageSrc: "/images/neural_network.png",
        techStack: "Python, NumPy, Neural Networks, Sigmoid, ReLU, Binary Cross-Entropy, XOR Problem, NYC Taxi Trip Dataset, Data Preprocessing.",
        category: "Aritificial Intelligence / Machine Learning",
        description: "This project builds a neural network library from scratch, solves the XOR problem, and predicts NYC taxi trip durations using multi-layer networks with ReLU and sigmoid activations.",
        link: "https://github.com/anamolkhadka/neural-network-xor-taxi-regression"
    },
    {
        title: "Decision Trees, Random Forests, and AdaBoost",
        imageSrc: "/images/decision_trees.png",
        techStack: "Python, Decision Trees, Random Forest, AdaBoost, Entropy, Gini Index, Titanic Dataset, Ensemble Learning.",
        category: "Aritificial Intelligence / Machine Learning",
        description: "This project implements decision trees, random forests, and AdaBoost classifiers from scratch, evaluated on the Titanic dataset with feature engineering and accuracy comparison.",
        link: "https://github.com/anamolkhadka/decision-tree-rf-adaboost-titanic"
    },
    {
        title: "Deep Learning for Image Classification",
        imageSrc: "/images/deep_learning.png",
        techStack: "Python, PyTorch Lightning, CNN, ResNet18, Data Augmentation, Transfer Learning, Imagenette, CIFAR10.",
        category: "Aritificial Intelligence / Machine Learning",
        description: "This project implements CNNs and ResNet18 architectures on Imagenette, adds data augmentation, and applies transfer learning to fine-tune models on the CIFAR10 dataset.",
        link: "https://github.com/anamolkhadka/deep-learning-imagenette-cifar10"
    },
    {
        title: "Reinforcement Learning with Q-Learning & DQN",
        imageSrc: "/images/pong.jpg",
        techStack: "Python, Gymnasium, Q-Learning, Policy Iteration, Deep Q-Network (DQN), FrozenLake, Atari Pong, PyTorch.",
        category: "Aritificial Intelligence / Machine Learning",
        description: "This project implements Q-Learning and Deep Q-Network (DQN) agents to solve the FrozenLake and Atari Pong environments, with hyperparameter tuning and performance analysis.",
        link: "https://github.com/anamolkhadka/reinforcement-learning-q-dqn"
    },
    {
        title: "Simon Game",
        imageSrc: "/images/SimonGame.png",
        techStack: "HTML, CSS, JavaScript, jQuery",
        category:"Front-end application",
        description: `This is a web-based implementation of the classic Simon game. The game tests your memory and pattern recognition skills as you attempt to replicate increasingly 
        complex sequences of colored buttons and tones.`,
        link: "https://anamolkhadka.github.io/simon_game/"
    },
    {
        title: "Drum Kit",
        imageSrc: "/images/DrumKit.png",
        techStack: "HTML, CSS, JavaScript, jQuery",
        category:"Front-end application",
        description: `This is a Drum Kit website that allows user to play drum sounds using the keys or button clicks.`,
        link: "https://anamolkhadka.github.io/DrumKit/"
    },
    {
        title: "ToDoList",
        imageSrc: "/images/ToDoList.png",
        techStack: "EJS, CSS, Bootstrap, JavaScript, Express, Node, npm, Axios, SQL, Postgres",
        category:"Full-stack application",
        description: `This is a simple CRUD based To Do List web application that allows users to create, read, update, and delete items from the list.`,
        link: "https://github.com/anamolkhadka/ToDoList"
    },
    {
        title: "Tip App",
        imageSrc: "/images/Tip_App.png",
        techStack: "Kotlin, XML, Android Studio",
        category:"Mobile application",
        description: `This is a simple Android App that can be handy whenever people visit restaurants, cafe, salons or other service oriented businesses 
        and want to tip people for their service. It is simple and easy to use that does math for you and also helps to know the tip and the total amount after rounding up.`,
        link: "https://github.com/anamolkhadka/Tip_App"
    },
]

export const ResearchPublications = [
    {
        title: "Comparative Evaluation of Traditional Machine Learning and Deep CNN Models for Static Hand Gesture Recognition",
        authors: ["Anamol Khadka", "Prit Desai"],
        journal: "MavMatrix, UTA's Institutional Repository and Archival Hub",
        year: 2025,
        link: "https://mavmatrix.uta.edu/cse_studentresearch/2/",
        description: "This study presents a comparative evaluation of traditional machine learning models and a deep convolutional neural network (CNN) for static hand gesture classification."
    },
    {
        title: "Credit Card Fraud Detection via Model Retraining and Fine-Tuning",
        authors: ["Anamol Khadka"],
        journal: "MavMatrix, UTA's Institutional Repository and Archival Hub",
        year: 2025,
        link: "https://mavmatrix.uta.edu/cse_studentresearch/1/",
        description: "A research‑grade exploration of how temporal validation and continual learning impact credit‑card fraud detection performance."
    },
    {
        title: "CRITICAL AUDIT MATTERS IN ACCOUNTING: ANALYSIS AND STUDY OF THE TOP 100 COMPANIES FROM S&P 500 INDEX FOR FISCAL YEARS 2021 AND 2022",
        authors: ["Anamol Khadka"],
        journal: "MavMatrix, UTA's Institutional Repository and Archival Hub",
        year: 2022,
        link: "https://mavmatrix.uta.edu/honors_fall2022/9/",
        description: "An analysis of critical audit matters in accounting, focusing on the top 100 companies from the S&P 500 index for fiscal years 2021 and 2022 and their audit reports."
    }
]